import { configureStore } from '@reduxjs/toolkit'
import AdminInviteReducer from './AdminInviteReducer'
import AdminReducer from './AdminReducer'
import AudiencesReducer from './AudiencesReducer'
import ClusterReducer from './ClusterReducer'
import CurrencyReducer from './CurrencyReducer'
import ExternalBookingAPIKeyReducer from './ExternalBookingAPIKeyReducer'
import FeaturedVenuesReducer from './FeaturedVenuesReducer'
import FormCardReducer from './FormCardReducer'
import LegalDocumentReducer from './LegalDocumentReducer'
import LegalDocumentVersionReducer from './LegalDocumentVersionReducer'
import LoyaltyTierReducer from './LoyaltyTierReducer'
import MenuReducer from './MenuReducer'
import NotificationContentReducer from './NotificationContentReducer'
import NotificationReducer from './NotificationReducer'
import PermissionReducer from './PermissionReducer'
import ReservationReducer from './ReservationReducer'
import RoleReducer from './RoleReducer'
import SearchReducer from './SearchReducer'
import SeatingAreaReducer from './SeatingAreaReducer'
import SegmentReducer from './SegmentReducer'
import SettingReducer from './SettingReducer'
import TestUserReducer from './TestUserReducer'
import UserReducer from './UserReducer'
import VenueReducer from './VenueReducer'
import VenueSeatingAreaReducer from './VenueSeatingAreaReducer'
import VenueTagReducer from './VenueTagReducer'
import VenueTypeReducer from './VenueTypeReducer'
import VenuesCollectionReducer from './VenuesCollectionReducer'
import WhatsappBotSettingReducer from './WhatsappBotSettingReducer'
import ComplementaryItemReducer from './balance/ComplementaryItemReducer'
import BillingMethodReducer from './business/BillingMethodReducer'
import BusinessProfileReducer from './business/BusinessProfileReducer'
import BusinessProfileStatusReducer from './business/BusinessProfileStatusReducer'
import BusinessVerifierReducer from './business/BusinessVerifierReducer'
import CompanyContactReducer from './business/CompanyContactReducer'
import CompanyReducer from './business/CompanyReducer'
import CompanyStatusReducer from './business/CompanyStatusReducer'
import dayReducer from './business/DayReducer'
import PolicyReducer from './business/PolicyReducer'
import ShiftReducer from './business/ShiftReducer'
import CouponReducer from './membership/CouponReducer'
import EventParticipationReducer from './membership/EventParticipationReducer'
import EventReducer from './membership/EventReducer'
import EventsCollectionReducer from './membership/EventsCollectionReducer'
import FormAnswerReducer from './membership/FormAnswerReducer'
import FormQuestionOptionReducer from './membership/FormQuestionOptionReducer'
import FormQuestionReducer from './membership/FormQuestionReducer'
import MembershipIncomingRenewalReducer from './membership/MembershipIncomingRenewalReducer'
import MembershipProfileComplementaryItemReducer from './membership/MembershipProfileComplementaryItemReducer'
import MembershipProfileCurrencyReducer from './membership/MembershipProfileCurrencyReducer'
import MembershipProfileReducer from './membership/MembershipProfileReducer'
import MembershipProfileTagReducer from './membership/MembershipProfileTagReducer'
import MembershipTransactionReducer from './membership/MembershipTransactionReducer'
import ParticipationStatusReducer from './membership/ParticipationStatusReducer'
import PerkReducer from './membership/PerkReducer'
import PlanReducer from './membership/PlanReducer'
import ProgramComplementaryItemReducer from './membership/ProgramComplementaryItemReducer'
import ProgramCurrencyReducer from './membership/ProgramCurrencyReducer'
import ProgramReducer from './membership/ProgramReducer'
import SubscriptionReducer from './membership/SubscriptionReducer'
import SubscriptionTagReducer from './membership/SubscriptionTagReducer'
import VenueIntegrationReducer from './venue/VenueIntegrationReducer'
import AdyenConfigReducer from './venue/integrations/AdyenConfigReducer'
import DominoConfigReducer from './venue/integrations/DominoConfigReducer'
import SevenroomsAudienceReducer from './venue/integrations/SevenroomsAudienceReducer'
import SevenroomsVenueGroupReducer from './venue/integrations/SevenroomsVenueGroupReducer'

export const store = configureStore({
  reducer: {
    admin: AdminReducer,
    adminInvite: AdminInviteReducer,
    adyenConfig: AdyenConfigReducer,
    audiences: AudiencesReducer,
    billingMethod: BillingMethodReducer,
    businessProfile: BusinessProfileReducer,
    businessProfileStatus: BusinessProfileStatusReducer,
    businessVerifier: BusinessVerifierReducer,
    cluster: ClusterReducer,
    company: CompanyReducer,
    companyContact: CompanyContactReducer,
    companyStatus: CompanyStatusReducer,
    complementaryItem: ComplementaryItemReducer,
    coupon: CouponReducer,
    currency: CurrencyReducer,
    day: dayReducer,
    dominoConfig: DominoConfigReducer,
    event: EventReducer,
    eventParticipation: EventParticipationReducer,
    eventsCollection: EventsCollectionReducer,
    externalBookingAPIKey: ExternalBookingAPIKeyReducer,
    featuredVenues: FeaturedVenuesReducer,
    formAnswer: FormAnswerReducer,
    formCard: FormCardReducer,
    formQuestion: FormQuestionReducer,
    formQuestionOption: FormQuestionOptionReducer,
    legalDocument: LegalDocumentReducer,
    legalDocumentVersion: LegalDocumentVersionReducer,
    loyaltyTier: LoyaltyTierReducer,
    membershipIncomingRenewal: MembershipIncomingRenewalReducer,
    membershipProfile: MembershipProfileReducer,
    membershipProfileComplementaryItem:
      MembershipProfileComplementaryItemReducer,
    membershipProfileCurrency: MembershipProfileCurrencyReducer,
    membershipProfileTag: MembershipProfileTagReducer,
    membershipTransaction: MembershipTransactionReducer,
    menu: MenuReducer,
    notification: NotificationReducer,
    notificationContent: NotificationContentReducer,
    participationStatus: ParticipationStatusReducer,
    perk: PerkReducer,
    permission: PermissionReducer,
    plan: PlanReducer,
    policy: PolicyReducer,
    program: ProgramReducer,
    programComplementaryItem: ProgramComplementaryItemReducer,
    programCurrency: ProgramCurrencyReducer,
    reservation: ReservationReducer,
    role: RoleReducer,
    search: SearchReducer,
    seatingArea: SeatingAreaReducer,
    segment: SegmentReducer,
    setting: SettingReducer,
    sevenroomsAudience: SevenroomsAudienceReducer,
    sevenroomsVenueGroup: SevenroomsVenueGroupReducer,
    shift: ShiftReducer,
    subscription: SubscriptionReducer,
    subscriptionTag: SubscriptionTagReducer,
    testUser: TestUserReducer,
    user: UserReducer,
    venue: VenueReducer,
    venueIntegration: VenueIntegrationReducer,
    venueSeatingArea: VenueSeatingAreaReducer,
    venueTag: VenueTagReducer,
    venueType: VenueTypeReducer,
    venuesCollection: VenuesCollectionReducer,
    whatsappBotSetting: WhatsappBotSettingReducer,
  },
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch
